export const GLOBALS_RESET_STATE = 'GLOBALS_RESET_STATE';
export const GLOBALS_CURRENT_ITEM = 'GLOBALS_CURRENT_ITEM';

export const GLOBALS_REQUEST_LOADING = 'GLOBALS_REQUEST_LOADING';
export const GLOBALS_REQUEST_SUCCESS = 'GLOBALS_REQUEST_SUCCESS';
export const GLOBALS_REQUEST_FAILED = 'GLOBALS_REQUEST_FAILED';

export const GLOBALS_CURRENT_ACTION = 'GLOBALS_CURRENT_ACTION';
export const GLOBALS_RESET_ACTION = 'GLOBALS_RESET_ACTION';